import _some from 'lodash.some'

const hasAny = (objectPerms, lookingForPerms) => {
  if (!objectPerms || !Array.isArray(objectPerms)) {
    return false
  }
  return _some(objectPerms, objPerm => {
    return _some(lookingForPerms, lookingFor => lookingFor === objPerm)
  })
}

export const isOwner = (obj) => {
  if (!obj) return false
  return hasAny(obj.permissions, ['OWNER'])
}

export const canEdit = (obj) => {
  if (!obj) return false
  return hasAny(obj.permissions, ['OWNER', 'EDITOR'])
}

export const canView = (obj) => {
  if (!obj) return false
  return hasAny(obj.permissions, ['OWNER', 'EDITOR', 'VIEWER'])
}

export const isMember = (obj) => {
  if (!obj) return false
  return hasAny(obj.permissions, ['MEMBER'])
}
